import {DatePickerMonths} from "./Globals.ts";

function yearmonthToTimestamp(yearmonth: string, dpMonths: typeof DatePickerMonths) {
    if (yearmonth.trim() === '') {
        console.warn('yearmonth is empty string');
        return null;
    }
    const d = new Date();
    const [monthStr, yearStr] = yearmonth.split(' ');
    const month = dpMonths.indexOf(monthStr);
    const year = parseInt(yearStr);
    d.setDate(1);
    d.setMonth(month);
    d.setFullYear(year);
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d.getTime();
}

export {yearmonthToTimestamp};